
import * as CONST from 'common/const';
import createReducer from './createReducer';

const initialState = {
  saving: false,
  error: ''
}

export default createReducer(initialState, {
  [CONST.SAVE_CALCDETAILS_REQUEST]: state => ({
    ...state,
    saving: true,
    error: ''
  }),

  [CONST.SAVE_CALCDETAILS_SUCCESS]: state => ({
    ...state,
    saving: false,
    error: ''
  }),

  [CONST.SAVE_CALCDETAILS_FAILURE]: (state, action) => ({
    ...state,
    saving: false,
    error: action.payload
  }),
});
